import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '@stores/store';
import { IMyInfo } from 'interfaces/my-info';

export type TMyInfoInitialState = Partial<IMyInfo>;

const initialState: Partial<TMyInfoInitialState> = {};

export const myInfoSelector = (state: RootState) => state.myInfo;

export const popupSlice = createSlice({
  name: 'myInfo',
  initialState,
  reducers: {
    setMyInfo: (state, action) => {
      state = action.payload;
      return state;
    },
    setMyInfoSpread: (state, action) => {
      const _state = {
        ...state,
        ...action.payload,
      };
      return _state;
    },
  },
});

export const { setMyInfo, setMyInfoSpread } = popupSlice.actions;

export default popupSlice.reducer;
